import React from "react";
import { WarningAlert } from "@/components/ui/alert";
import { useTranslation } from "@/hooks/useTranslation";

type CartItemErrorProps = {
  errors: Array<Record<string, string[]>> | null | undefined;
};

const CartItemError = ({ errors }: CartItemErrorProps) => {
  const { t } = useTranslation();
  if (!errors || errors.length === 0) {
    return null;
  }

  const errorMessages: string[] = [];
  errors.forEach((errorObj) => {
    Object.values(errorObj).forEach((messages) => {
      if (Array.isArray(messages)) {
        errorMessages.push(
          ...messages.filter(
            (msg) => typeof msg === "string" && msg.trim() !== "",
          ),
        );
      }
    });
  });

  if (errorMessages.length === 0) {
    return null;
  }

  // If there's only one error message, show it directly
  if (errorMessages.length === 1) {
    const firstMessage = errorMessages[0];
    if (!firstMessage) return null;

    return (
      <div className="mt-3">
        <WarningAlert message={firstMessage} />
      </div>
    );
  }

  // If there are multiple error messages, show them as a list with line breaks
  return (
    <div className="mt-3">
      <WarningAlert
        message={
          <div className="space-y-1">
            {errorMessages.map((message, index) => (
              <div key={index}>{message}</div>
            ))}
          </div>
        }
        title={t("multiple_issues_found")}
      />
    </div>
  );
};

export default CartItemError;
